import React from 'react';

const CloseIcon = () => (
  <svg width="24" height="25">
    <path
      d="M23.406 1.442c.767.78.79 2.012.077 2.819l-.101.107-8.456 8.315 8.48 8.621c.766.78.79
      2.012.078 2.819l-.102.107a2.07 2.07 0 0 1-2.819.078l-.107-.102-8.315-8.454L3.52 24.23a2.069
      2.069 0 0 1-3.003-2.843l.101-.107 8.456-8.314-8.48-8.622a2.07 2.07 0 0 1-.078-2.819l.102-.107a2.07
      2.07 0 0 1 2.819-.078l.107.102 8.314 8.453 8.622-8.477a2.069 2.069 0 0 1 2.926.024z"
      fill="#393434"
      fillRule="nonzero"
    />
  </svg>
);

export default CloseIcon;
